import { StructuredLog } from "@agentx/agentx-services";
import { ensureError } from "@uuip/unified-ui-platform-sdk";
import { v4 as uuid } from "uuid";
import { getWebexInstance } from "../webex/webex-initialization";
export const PRE_LOGIN_ID_KEY = "preLoginId";
export function getBrowserInstanceId() {
    const browserInstanceID = localStorage.getItem("browserInstanceID");
    if (browserInstanceID) {
        return browserInstanceID;
    }
    const newBrowserInstanceID = uuid();
    localStorage.setItem("browserInstanceID", newBrowserInstanceID);
    return newBrowserInstanceID;
}
async function submitPreLoginEvent(name, payload, preLoginId) {
    const webex = getWebexInstance();
    const newMetrics = webex?.internal.newMetrics;
    if (!newMetrics) {
        StructuredLog.error(name, "Webex metrics not initialised");
        return Promise.reject(new Error("Webex metrics not initialised"));
    }
    try {
        const metadata = { appType: "Web Client", browserInstanceId: getBrowserInstanceId() };
        const sessionId = localStorage.getItem("ClientLogSessionID");
        if (sessionId) {
            metadata.sessionId = sessionId;
        }
        return await newMetrics.submitPreLoginEvent({
            name,
            preLoginId,
            payload,
            metadata
        });
    }
    catch (error) {
        StructuredLog.error(name, "Failed to submit pre-login event", ensureError(error));
        return Promise.reject(ensureError(error));
    }
}
const PRE_LOGIN_METRICS_TIMEOUT_MS = 5000;
function withMetricsTimeout(metricsPromise, onTimeout) {
    let timeoutId;
    const timeout = new Promise((resolve) => {
        timeoutId = setTimeout(() => {
            onTimeout();
            resolve();
        }, PRE_LOGIN_METRICS_TIMEOUT_MS);
    });
    return Promise.race([metricsPromise, timeout]).finally(() => {
        clearTimeout(timeoutId);
    });
}
export async function submitPreLoginEventBeforeRedirect(name, payload, preLoginId) {
    let didTimeout = false;
    await withMetricsTimeout(submitPreLoginEvent(name, payload, preLoginId)
        .then(() => {
        if (!didTimeout && preLoginId) {
            localStorage.setItem(PRE_LOGIN_ID_KEY, preLoginId);
        }
    })
        .catch((error) => {
        StructuredLog.error(name, "Failed to submit pre-login event", ensureError(error));
    }), () => {
        didTimeout = true;
    });
}
